<svg
  class="loading-spinner"
  viewBox="0 0 8 8"
  [ngStyle]="{ 'width.px': width, 'height.px': width }"
>
  <defs>
    <linearGradient id="gradient" x1="0%" x2="50%" y1="50%" y2="26.212%">
      <stop offset="0%" [attr.stop-color]="secondColor" stop-opacity="-.731" />
      <stop offset="100%" [attr.stop-color]="color" />
    </linearGradient>
  </defs>
  <path
    fill="url(#gradient)"
    d="M4 0A3.972 3.972 0 0 0 .941 1.451l1.53 1.276A1.986 1.986 0 0 1 4 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2H0a4 4 0 1 0 4-4"
  ></path>
</svg>
